import { LibraryPanel } from "@/components/LibraryPanel";

export default function AdminLibrary() {
  return (
    <div>
      <div className="mb-8">
        <div className="overline mb-2">Administration</div>
        <h1 className="font-dash text-3xl">Document Library</h1>
        <p className="text-zinc-500 mt-2 text-sm">Store firm documents and templates. Mark an item as <span className="text-emerald-400">Shared</span> to publish it to every client's portal.</p>
      </div>
      <LibraryPanel isAdmin />
    </div>
  );
}
